import { RuleCategory } from '../../../common/enums/RuleCategory';
import { Ruleset } from '../../../common/enums/Ruleset';
import { TraceType } from '../../../common/enums/TraceType';
import { AnalyzerRule } from './valueObjects/AnalyzerRule';

export class TracerRule extends AnalyzerRule {
  constructor(
    number: number,
    title: string,
    category: RuleCategory,
    ruleset: Ruleset,
    shortExplanation: string,
    private readonly compatibleTraceTypes: Set<TraceType>
  ) {
    super(number, title, category, ruleset, shortExplanation);
  }

  getCompatibleTraceTypes() {
    return this.compatibleTraceTypes;
  }
}
